import styled from 'styled-components'
import { Button } from 'antd'

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  padding-top: 25px;

  .field-label {
    width: 52%;
  }
`

export const StyledButton = styled(Button)`
  align-self: flex-end;
`
